
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Components/Home/Home";
import TourTypeViewMore from "./Components/TourTypeSection/TourTypeViewMore";
import SoloTrip from "./Components/TourTypeSection/SoloTrip";
import HolidayViewMore from "./Components/HolidaySection/HolidayViewMore";
import NormalTourViewMore from "./Components/NormalTourPackage/NormalTourViewMore";
import DestinationViewMore from "./Components/DestinationSection/DestinationViewMore";
import WhatYouGet from "./Components/PlanTripSection/WhatYouGet";
import TravelPlanning from "./Components/PlanTripSection/TravelPanning";
import Form1 from "./Components/PlanTripSection/Form1";
import Form2 from "./Components/PlanTripSection/Form2";
import Form3 from "./Components/PlanTripSection/Form3";
import Form4 from "./Components/PlanTripSection/Form4";
import Form5 from "./Components/PlanTripSection/Form5";
import Form6 from "./Components/PlanTripSection/Form6";
import Form7 from "./Components/PlanTripSection/Form7";
import Form8 from "./Components/PlanTripSection/Form8";
import RequestCallBack from "./Components/TrustSupportSection/RequestCallBack";
import EnquiryForm from "./Components/TrustSupportSection/EnquiryForm";
import BeachTrip from "./Components/TourTypeSection/BeachTrip";
import GroupTrip from "./Components/TourTypeSection/GroupTrip";
import FamilyTrip from "./Components/TourTypeSection/FamilyTrip";
import HoneymoonTrip from "./Components/TourTypeSection/HoneymoonTrip";
import AdventureTrip from "./Components/TourTypeSection/AdventureTrip";
import LuxuryTrip from "./Components/TourTypeSection/LuxuryTrip";

import WeekendGetawayTrip from "./Components/TourTypeSection/WeekendGetawayTrip";
import RoadTrip from "./Components/TourTypeSection/RoadTrip";
import BackpackingTrip from "./Components/TourTypeSection/BackpackingTrip";
import ReligiousTrip from "./Components/TourTypeSection/ReligiousTrip";
import WildlifeSafariTrip from "./Components/TourTypeSection/WildlifeSafariTrip";
import HillTrip from "./Components/TourTypeSection/HillTrip";
import CorporateTrip from "./Components/TourTypeSection/CorporateTrip";
import CoupleTrip from "./Components/TourTypeSection/CoupleTrip";
import FestivalTrip from "./Components/TourTypeSection/FestivalTrip";
import TourPackagesViewMore from "./Components/TourPackageSection/TourPackagesViewMore";
import TourPackageData from "./Components/TourPackageSection/TourPackageData";
import GuidancePage from "./Components/TrustSupportSection/GuidancePage";
import BooknowInfo from "./Components/TourPackageSection/BooknowInfo";
import GuestInfo from "./Components/TourPackageSection/GuestInfo";
import Payment from "./Components/TourPackageSection/Payment";
import Success from "./Components/TourPackageSection/Success";
import Failed from "./Components/TourPackageSection/Failed";
function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tour-type-view-more" element={<TourTypeViewMore />} />
          <Route path="/solo-trip" element={<SoloTrip />} />
          <Route path="/beach-trip" element={<BeachTrip />} />
          <Route path="/group-trip" element={<GroupTrip />} />
          <Route path="/family-trip" element={<FamilyTrip />} />
          <Route path="/honeymoon-trip" element={<HoneymoonTrip />} />
          <Route path="/adventure-trip" element={<AdventureTrip />} />
          <Route path="/backpacking-trip" element={<BackpackingTrip />} />
          <Route path="/religious-trip" element={<ReligiousTrip />} />
          <Route path="/hill-trip" element={<HillTrip />} />
          <Route
            path="/wildlife-safari-trip"
            element={<WildlifeSafariTrip />}
          />
          <Route path="/corporate-trip" element={<CorporateTrip />} />
          <Route path="/couple-trip" element={<CoupleTrip />} />
          <Route
            path="/weekend-getaway-trip"
            element={<WeekendGetawayTrip />}
          />
          <Route path="/luxury-trip" element={<LuxuryTrip />} />
          <Route path="/road-trip" element={<RoadTrip />} />

          <Route path="/holiday-view-more" element={<HolidayViewMore />} />
          <Route path="/festival-trip" element={<FestivalTrip />} />
          <Route
            path="/normal-tour-view-more"
            element={<NormalTourViewMore />}
          />
          <Route
            path="/destination-view-more"
            element={<DestinationViewMore />}
          />
          <Route path="/what-you-get" element={<WhatYouGet />} />
          <Route path="/travel-panning" element={<TravelPlanning />} />
          <Route path="/form-page" element={<Form1 />} />
          <Route path="/form2" element={<Form2 />} />
          <Route path="/form3" element={<Form3 />} />
          <Route path="/form4" element={<Form4 />} />
          <Route path="/form5" element={<Form5 />} />
          <Route path="/form6" element={<Form6 />} />
          <Route path="/form7" element={<Form7 />} />
          <Route path="/form8" element={<Form8 />} />
          <Route path="/request-call-back" element={<RequestCallBack />} />
          <Route path="/enquiry-form" element={<EnquiryForm />} />
          <Route
            path="/tour-package-view-more"
            element={<TourPackagesViewMore />}
          />
          <Route path="/guidance-page" element={<GuidancePage/>}/>
          <Route path="/tour-package-data" element={<TourPackageData />} />
          <Route path="/book-now-info" element={<BooknowInfo />} />
          <Route path="/guest-details" element={<GuestInfo />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/success" element={<Success />} />
          <Route path="/failed" element={<Failed/>}/>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
